<template>
    <div v-if="listObject.length > 0" style="font-size: 10px">

        <div v-for="header in listObject">
            <div :style="header.headerStyle">
                <div v-if="header.items != undefined">
                    <div v-bind:key="index"
                         v-for="(s_item, index) in header.items">
                        <div v-if="s_item[header.itemValue] == keyValue">
                            {{ s_item[header.itemText] }}
                        </div>
                        <div v-if="s_item[header.itemValue] == keyValue && header.unitText !=undefined">
                            ({{ s_item[header.unitText] }})
                        </div>

                    </div>
                </div>
                <div v-else>
                    {{keyValue}}
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        {{keyValue}}
    </div>
</template>

<script>
    export default {
        name: "SelectBoxView",
        props: {
            listObject: {
                type: [Array, Object],
                default: () => []
            },

            keyValue:{
                type: Number,
                default: -1
            }
        },
        watch:{

        }
    }
</script>

<style scoped>

</style>